<template>
  <el-row>
    <el-col :xs="24">
      <el-card
        v-loading="isLoading">
        <div slot="header" class="clearfix">
          <span class="cadastro-title">Pergunta -  {{ isEditing ? 'Editar' : 'Visualizar'}}</span>
          <a class="pull-right" style="cursor: pointer" @click="toList()"><i class="icon-close"></i></a>
        </div>
        <el-form label-position="left" label-width="100px" :model="selected" ref="selected" v-if="selected">

          <el-form-item label="Descrição" :error="errors.descricao">
            <el-input v-model="selected.descricao" :readonly="!isEditing"/>
          </el-form-item>

          <el-form-item label="Grupo"  :error="errors.pergunta_grupo_id" :md="8">
            <el-select v-model="selected.pergunta_grupo_id" filterable placeholder="Selecione" :disabled="! isEditing">
              <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item align="right">
            <el-button type="danger" @click="excluir()">Excluir</el-button>
            <el-button type="success" @click="toList()">Lista</el-button>
            <el-button type="warning" v-show="! isEditing" @click="isEditing = true">Editar</el-button>
            <el-button type="primary" @click="onSubmit" v-show="isEditing">Salvar</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<style>
  .centrocusto-show-card-seeder .el-card__header {
    color: #ffffff;
    background-color: #2E2E2E;
  }
</style>

<script>

  import {error_form_transform} from "../../domain/utils";
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "pergunta-show",
    data() {
      return {
        isLoading: false,
        isEditing: false,
        errors: {
          descricao: null,
          pergunta_grupo_id: null
        }
      }
    },
    computed: {
      ...mapState('Pergunta', ['selected']),
      ...mapState( 'PerguntaGrupo', ['list']),
      id() {
        return this.$route.params.pergunta
      }
    },
    methods: {
      ...mapActions('Pergunta', ['setSelected' , 'update']),
      ...mapActions('PerguntaGrupo', ['setList' ]),
      async onSubmit() {
        try {
          this.isLoading = true
          await this.update(this.selected)
          this.$notify.success("Registro Atualizado com sucesso!")
        }
        catch (error) {
          if (_.isObjectLike(error.response)) {
            this.errors = error_form_transform(error.response.data.errors)
          }
          console.log(error)
        }
        finally {
          this.isLoading = false
        }
      },
      async excluir() {
        this.$confirm('Deseja excluir este registro?', 'Cuidado', {
          confirmButtonText: 'Sim', cancelButtonText: 'Não Excluir', type: 'warning'
        }).then(async () => {
          this.isProcessing = true
          try {
            await axios.delete(`${process.env.API_PATH}/pergunta/${this.id}`)
            this.$message({type: 'success', message: 'Excluido com sucesso!'});
            this.toList()
          } catch (error) {
            this.$message({type: 'danger', message: 'Erro ao excluir contate o admisnistrador do sistema!'});
          }
          this.isProcessing = false
        }).catch(() => {
          this.$message({type: 'info', message: 'Ação Cancelada'});
        });
      },
      toList() {
        this.$router.push({name: 'pergunta.index'})
      }
    },
    async mounted() {
      try {
        this.isLoading = true
        await this.setSelected({id: this.id})
        await this.setList()
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/features/Pergunta/Show.vue